"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var addReadWriteRecipient_1 = require("./addReadWriteRecipient");
var processGetGroupInfoResult_1 = require("./processGetGroupInfoResult");
var removeReadWriteRecipient_1 = require("./removeReadWriteRecipient");
var getGroupInfo_1 = require("../services/getGroupInfo");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('expandGroup')(function expandGroup(recipientWell, recipientToExpand) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupResponse, expandedEmails;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    recipientToExpand.isExpanding = true;
                    return [4 /*yield*/, getGroupInfo_1.getGroupInfo(recipientToExpand.persona.PersonaId, recipientToExpand.persona.ADObjectId, recipientToExpand.persona.EmailAddress)];
                case 1:
                    groupResponse = _a.sent();
                    recipientToExpand.isExpanding = false;
                    expandedEmails = [];
                    processGetGroupInfoResult_1.default(expandedEmails, groupResponse);
                    removeReadWriteRecipient_1.default(recipientWell, recipientToExpand);
                    expandedEmails.forEach(function (member) {
                        addReadWriteRecipient_1.default(recipientWell, true /* isValid */, member, null /* newEmailAddress */);
                    });
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=expandGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/expandGroup.js
// module id = 3405
// module chunks = 2 3